module.exports = __webpack_public_path__ + "static/media/entry-background.9e9ffcc9.png";